export default [
  {
    path: '/home',
    name: 'home',
    meta: {
      index: 1
    },
    component: () =>
      import(/* webpackChunkName: "��ҳ" */ '@/pages/home/index.vue')
  },
  {
    path: '/seckill',
    name: 'seckill',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "seckill-index" */ '@/pages/home/seckill/index.vue')
  },
  {
    path: '/medicare',
    name: 'medicare',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "medicare" */ '@/pages/home/medicare/index.vue')
  },
  {
    path: '/special',
    name: 'special',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "special" */ '@/pages/home/special/index.vue')
  },
  {
    path: '/gifts',
    name: 'gifts',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "gifts" */ '@/pages/home/gifts/index.vue')
  },
  {
    path: '/activity',
    name: 'activity',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "activity" */ '@/pages/home/activity/index.vue')
  },
  {
    path: '/promotionlist',
    name: 'promotionlist',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "activity" */ '@/pages/home/promotionlist/index.vue')
  },
  {
    path: '/presell',
    name: 'presell',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "presell" */ '@/pages/home/presell/index.vue')
  },
  {
    path: '/regionsell',
    name: 'regionsell',
    meta: {
      index: 1.1
    },
    component: () =>
      import(/* webpackChunkName: "regionsell" */ '@/pages/home/regionsell/index.vue')
  }
]
